import React from "react";
import { motion } from "framer-motion";
import "./TeamSection.css";

const TeamSection = () => {
  const teamMembers = [
    {
      name: "Dr. Arez",
      role: "CEO & Founder",
      image: "images/arez.png", // You'll add these images later
    },
    {
      name: "Ali",
      role: "Creative Director",
      image: "images/ali.png",
    },
    {
      name: "Shaida",
      role: "Digital Director",
      image: "images/shaida.png",
    },
    {
      name: "Goran",
      role: "Sales Director",
      image: "images/goran.png",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
  };

  return (
    <section className="team-section">
      <div className="team-container">
        <motion.h2
          className="team-title"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          Meet the minds <span className="yellow-text">moving the needle</span>
        </motion.h2>

        <motion.div
          className="team-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {teamMembers.map((member, index) => (
            <motion.div
              key={index}
              className="team-member"
              variants={itemVariants}
            >
              <div className="team-member-image-container">
                <div
                  className="team-member-image"
                  style={{ backgroundImage: `url(${member.image})` }}
                ></div>
                <div className="team-member-overlay"></div>
              </div>
              <div className="team-member-info">
                <h3 className="team-member-name">{member.name}</h3>
                <p className="team-member-role">{member.role}</p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default TeamSection;
